import React, { createContext, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';
import i18n from '../i18n';
import { getApplicant } from 'requests/dashboard.request';
import { IDbApplicant } from 'interfaces/applicant.interface';

interface MainContextType {
  applicantData: IDbApplicant;
  handleGetApplicant: VoidFunction;
}

const MainContext = createContext<MainContextType>({
  applicantData: {},
  handleGetApplicant: () => null,
});

export const useMain = (): MainContextType => useContext(MainContext);

export const MainProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }: { children: React.ReactNode }) => {
  const [applicantData, setApplicantData] = React.useState<IDbApplicant>({});

  const handleGetApplicant = () => {
    getApplicant()
      .then((res) => {
        setApplicantData(res);
      })
      .catch(() => toast.error(i18n.t('errors.invalidToken')));
  };

  useEffect(() => {
    handleGetApplicant();
  }, []);

  const value = { applicantData, handleGetApplicant };
  return <MainContext.Provider value={value}>{children}</MainContext.Provider>;
};
